/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

 import React from "react"
 import PropTypes from "prop-types"
 import { Helmet } from "react-helmet"
 import { ACTION_TYPES, getPriceStr, toTitleCase } from "./utilsMap"
 
 import _ from "lodash"
 export { ACTION_TYPES, ACTION_DESC_TYPES, getPriceStr } from "./utilsMap";
 
 const SeoResults = ({ description, lang, meta, title, searchParams, location, pcategorytype }) => {
 
   const {areas, bedrooms, pType, type, price, commType, mustInclude } = searchParams;

   var replace_url = pcategorytype+"_"+pType;
 
   const actionStr = ACTION_TYPES[replace_url];
   const priceStr = getPriceStr(price)
   const bedRooms = searchParams.bedrooms
   const pricerange = searchParams.price
 
   const capitalize = (s) => {
     if (typeof s !== 'string') return ''
     return s.charAt(0).toUpperCase() + s.slice(1)
   }
 
   let propertyType = ""
 
   if(type == "") {
     propertyType = "properties"
   } else if(type == "apartment") {
     propertyType = "apartments"
   } else if(type == "house") {
     propertyType = "houses"
   } else if(type == "bungalow") {
     propertyType = "bungalow"
   } else {
     propertyType = capitalize(type.replace(/-/g, ' '))
   }
 
   let desc = "";
   desc = "Explore our collection of "+ propertyType + actionStr + toTitleCase(areas.replace(/-/g, ' ')) +" Contact our LambornHill estate agents to find the right property"+ actionStr + toTitleCase(areas.replace(/-/g, ' '));

   if(bedrooms) {
    desc = "Find the latest "+ title + " Contact LambornHill estate agents and letting agents in " + toTitleCase(areas.replace(/-/g, ' ')) +", to arrange a viewing.";
   }

   if(pricerange.min || pricerange.max) {
    desc = "Locate the best "+ title +". Book a viewing with LambornHill estate agents in " + toTitleCase(areas.replace(/-/g, ' ')) +"."
   }

   if((pricerange.min || pricerange.max) && bedrooms) {
    desc = "Find "+ title + " with LambornHill. Contact one of our estate agents today to get assistance in finding the best property in " + toTitleCase(areas.replace(/-/g, ' ')) +".";
   } 
//    else {
//      // price
//      if (price.min || price.max){
//        desc = propertyType + actionStr + areas + "."
//      }
//    }
 
     //
     let titlePropertyType = ""
 
     if(type == "") {
         titlePropertyType = "Properties"
     } else if(type == "apartment") {
         titlePropertyType = "Apartments"
     } else if(type == "house") {
         titlePropertyType = "Houses"
     } else if(type == "maisonette") {
         titlePropertyType = "Maisonette"
     } else if(type == "property") {
         titlePropertyType = "Property"
     } else if(type == "bungalow") {
         titlePropertyType = "Bungalow"
     } else if(type == "land") {
         titlePropertyType = "Land"
     } else if(type == "commercial") {
         titlePropertyType = "Commercial"
     } else {
         titlePropertyType = type
     }
 
     let bedroomType = ""
 
     if ( bedrooms ) {
       bedroomType = bedrooms + ' + Bedroom '
     }
 
     let descTitle = bedroomType + toTitleCase(titlePropertyType.replace(/-/g, ' ')) + actionStr + toTitleCase(areas.replace(/-/g, ' ')) + priceStr
     //
 
   // console.log("Props Desc => ", desc);
 
   description = desc
 
   let metaItems = [
     {
       name: `description`,
       content: description,
     },
     {
       property: `og:title`,
       content: descTitle,
     },
     {
       property: `og:description`,
       content: description,
     },
     {
       property: `og:type`,
       content: `website`,
     },
     {
       name: `twitter:card`,
       content: `summary`,
     },
     {
       name: `twitter:creator`,
       content: `LambornHill`,
     },
     {
       name: `twitter:title`,
       content: descTitle,
     },
     {
       name: `twitter:description`,
       content: description,
     },
   ].concat(meta);
 
 
   // set no index for result pagination
   let hasPagination = false;
   if (location !== undefined && location.pathname) {
     let pageStr = location.pathname.split('page-');
     hasPagination = pageStr[1] || false;
   }
   if ( hasPagination ) {
     metaItems.push({
       name: `robots`,
       content: `noindex`,
     })
   }
 
   return (
     <Helmet
       htmlAttributes={{
         lang,
       }}
       title={descTitle}
       titleTemplate={`%s | LambornHill`}
       meta={metaItems}
     />
   )
 }
 
 SeoResults.defaultProps = {
   lang: `en`,
   meta: [],
   description: ``,
   title: ``,
   searchParams: [],
 }
 
 SeoResults.propTypes = {
   description: PropTypes.string,
   lang: PropTypes.string,
   meta: PropTypes.arrayOf(PropTypes.object),
   title: PropTypes.string.isRequired,
   searchParams: PropTypes.any,
 }
 
 export default SeoResults
 